import React from 'react';
import { BookOpenIcon, CheckIcon, PackageIcon } from 'lucide-react';
import { Section, SectionTitle } from './Section';
import { CTAButton } from '../CTAButton';
import { heroImage, volumes } from '../../data/content';
export function Volumes() {
  return <Section tone="white" data-id="element-280" data-mp="2x3ctnnpoddqw">
      <div className="text-center" data-id="element-281" data-mp="2szyd8vxtqvcx">
        <span className="inline-flex items-center gap-2 rounded-full bg-navy px-4 py-2 text-[11px] font-bold uppercase tracking-[0.16em] text-gold" data-id="element-282" data-mp="2sywpprzmggeb">
          <PackageIcon className="h-3.5 w-3.5" data-id="element-283" data-mp="2j9vbo7cn092z" />
          Inside the Blueprint
        </span>
      </div>

      <SectionTitle className="mt-5" data-id="element-284" data-mp="2eaiqdr1eza2i">
        What's Included in the Menopause Clinical Blueprint™
      </SectionTitle>

      <p className="mt-4 text-center text-[15px] leading-relaxed text-navy/70" data-id="element-285" data-mp="29cgweb2g9qc9">
        This isn't a single PDF. It's a complete clinical decision system
        designed to guide you through every stage of menopause management—from
        the initial consultation to long-term follow-up.
      </p>

      <ul className="mx-auto mt-5 flex max-w-md flex-col gap-2 text-center text-[14px] font-semibold text-navy/70" data-id="element-286" data-mp="335dzncjmj489">
        <li data-id="element-287" data-mp="37x4h02gzas96">Each volume eliminates uncertainty.</li>
        <li data-id="element-288" data-mp="2u4y20jpkarbb">Each framework simplifies decision-making.</li>
        <li data-id="element-289" data-mp="2u6iwyafsgc9p">Each algorithm helps you practice with greater confidence.</li>
      </ul>

      <img src={heroImage} alt="The six volumes of the Menopause Clinical Blueprint" className="mx-auto mt-6 w-full max-w-md" data-id="element-290" data-mp="2y7ci4w1ujcyw" />

      <div className="mt-8 space-y-5" data-id="element-291" data-mp="3quym45ezkjma">
        {volumes.map(volume => <article key={volume.number} className="rounded-3xl border border-navy/10 bg-cream p-5 sm:p-6" data-id="element-292" data-mp="3qsujrrwqjso4">
            <p className="flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.18em] text-gold-dark" data-id="element-293" data-mp="3htr12p1hdfa5">
              <BookOpenIcon className="h-4 w-4" data-id="element-294" data-mp="21fhbxspezmi9" />
              {volume.number}
            </p>
            <h3 className="mt-2 font-display text-xl font-bold leading-snug text-navy sm:text-2xl" data-id="element-295" data-mp="26geuw7i90kkt">
              {volume.title}
            </h3>
            <p className="mt-2.5 text-[14.5px] font-semibold leading-snug text-navy/85" data-id="element-296" data-mp="c0zjbxcbe2tv">
              {volume.lead}
            </p>
            <p className="mt-2 text-[14px] leading-relaxed text-navy/65" data-id="element-297" data-mp="28twt34u0dm2">
              {volume.body}
            </p>

            <p className="mt-4 text-[12px] font-bold uppercase tracking-[0.14em] text-navy/45" data-id="element-298" data-mp="3uc312xp7zhnn">
              {volume.introList}
            </p>
            <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-299" data-mp="3pbovrnf06ltb">
              {volume.items.map(item => <li key={item} className="flex items-start gap-2 text-[14px] leading-snug text-navy/80" data-id="element-300" data-mp="3ffvl69kuh2e6">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-dark" data-id="element-301" data-mp="3bfuunqkh10qr" />
                  {item}
                </li>)}
            </ul>
          </article>)}
      </div>

      <CTAButton className="mt-8" variant="navy" label="Unlock all 6 volumes now" subline="Value $297 — today only $27" data-id="element-302" data-mp="19nf0ey0twygw" />
    </Section>;
}